import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class CodeStandardDocumentModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (CodeStandardDocumentModel._instance == null) CodeStandardDocumentModel._instance = new CodeStandardDocumentModel(authManager);
        return CodeStandardDocumentModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'standards/code-standard-documents');

        this.entityName = 'standards.CodeStandardDocument';
        this.privileges = {
            create: [["adminStandards"]],
            read: [["adminStandards"],["manageStandards"],["editStandards"],["readStandards"]],
            update: [["adminStandards"]],
            delete: [["adminStandards"]],
        };

        this.label = 'Code Standard Document';
        this.setLabel = 'Code Standard Documents';

        this.browser = {
            name: 'default-standards-codestandarddocument-browser',
            moduleName: 'default-standards-codestandarddocument-browser',
            moduleTitle: 'Code Standard Documents',
            moduleStateSlotName: 'default-standards-codestandarddocument-browser',
        };

        this.editor = {
            name: 'default-standards-codestandarddocument-editor',
            moduleName: 'default-standards-codestandarddocument-editor',
            moduleTitle: 'Code Standard Document',
            moduleStateSlotName: 'default-standards-codestandarddocument-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'designation',
                type: 'string',
                persistent: true,
                label: 'Designation',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'typeId',
                type: 'CodeStandardDocumentType',
                persistent: true,
                label: 'Type',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'typeLabel',
                type: 'text',
                persistent: false,
                label: 'Type',
                distinctLabel: 'Type (Text)',
                readOnly: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'issueDate',
                type: 'local_date',
                persistent: true,
                label: 'Issue Date',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'applicableFromDate',
                type: 'local_date',
                persistent: true,
                label: 'Applicable From Date',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'link',
                type: 'string',
                persistent: true,
                label: 'Link',
                inEditor: true,
                inBrowser: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Comments',
                inEditor: true,
            },
        ];

    }

}
